<div class="view-customer">
  <mat-tab-group class="view-customer-tabs" animationDuration="0ms">
    <mat-tab [label]="'customerDetailsTitle' | translate">
      <div class="customer-details-container">
        <div class="customer-details-action-buttons">
          <button
            type="button"
            class="view-customer__edit-btn"
            (click)="openEditCustomerDialog()">
            <mat-icon>edit</mat-icon>{{ 'editCustomer' | translate }}
          </button>
        </div>
        <kzn-customer
          [customerDetails]="customerDetails"
          [isViewOnly]="true">
        </kzn-customer>
      </div>
    </mat-tab>
    <mat-tab [label]="'customerSubscriptionsTitle' | translate">
      <kzn-customer-subscriptions
        [customerID]="customerDetails.CustomerId"
        [customerSubscriptions]="customerDetails.Subscriptions"
        (customerSubscriptionCreated)="customerSubscriptionCreated.emit()">
      </kzn-customer-subscriptions>
    </mat-tab>
  </mat-tab-group>
</div>
